import { genQueryJsonStr } from '@/utils/querySchema'

export default function () {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const that = this
  const PATH_MAP = {
    renewalNum: '/workbench/contractRelationRecord/list', // 关联记录
    customerNum: '/driver/customerManage', // 客户管理
    default: '/workbench/rentOrder/list', // 个人租赁
  }
  function goPage(row, key, query = { }) {
    const path = PATH_MAP[key] || PATH_MAP.default
    if (PATH_MAP[key] === PATH_MAP.customerNum) {
      this.$router.push({
        path: PATH_MAP.customerNum,
        query,
      })
    } else {
      this.$router.push(`${path}?query=${genQueryJsonStr(query)}`)
    }
  }
  function renderContent(row, key, query) {
    return this.$createElement('span', {
      class: 'item-active',
      on: {
        click: () => { goPage.call(this, row, key, query) },
      },
    }, row[key])
  }

  const columns = [
    {
      name: 'deptName',
      columnProps: {
        label: '部门',
        prop: 'deptName',
      },
    },
    {
      name: 'customerNum',
      columnProps: {
        label: '新增用户数',
        prop: 'customerNum',
      },
      render: ({ row }) => {
        const query = {
          type: 'person',
        }
        return renderContent.call(this, row, 'customerNum', query)
      },
    },
    {
      name: 'orderNum',
      columnProps: {
        label: '新增订单数',
        prop: 'orderNum',
      },
      render: ({ row }) => {
        return renderContent.call(this, row, 'orderNum')
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'deliverCarNum',
      columnProps: {
        label: '交车数',
        prop: 'deliverCarNum',
      },
      render: ({ row }) => {
        const query = {
          search: {
            TheCarExTime: that.dateStr || '',
          },
        }
        return renderContent.call(this, row, 'deliverCarNum', query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'returnCarNum',
      columnProps: {
        label: '退车数',
        prop: 'returnCarNum',
      },
      render: ({ row }) => {
        const query = {
          search: {
            TheCarinStockTime: that.dateStr,
          },
        }
        return renderContent.call(this, row, 'returnCarNum', query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'orderGrowth',
      columnProps: {
        label: '当期净增订单数',
        prop: 'orderGrowth',
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'expiredNum',
      columnProps: {
        label: '当期合同到期数',
        prop: 'expiredNum',
      },
      render: ({ row }) => {
        const query = {
          tab: '2',
          search: {
            rentFinIsh: that.dateStr,
          },
        }
        return renderContent.call(this, row, 'expiredNum', query)
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'renewalNum',
      columnProps: {
        label: '当期续租数',
        prop: 'renewalNum',
      },
      render: ({ row }) => {
        const query = {
          tab: '4',
          search: {
            createdDate: that.dateStr,
          },
        }
        return renderContent.call(this, row, 'renewalNum', query)
      },
      columnHeaderTooltip: '',
    },
  ]
  return {
    columns,
  }
}
